import { Button } from '@ff-it/ui';
import { useTable } from 'components/ControlledTable';
import { useIndicatorsContext } from 'core/Indicators';
import { useListSeenToggle } from 'modules/notifications';
import type { Notification } from 'modules/notifications/types';
import type { ReactElement } from 'react';
import { fetcher } from 'services';
import invariant from 'tiny-invariant';

type NotificationSeenToggleProps = {
  notification: Notification;
};

export function NotificationSeenToggle({ notification }: NotificationSeenToggleProps): ReactElement {
  const handleToggle = useListSeenToggle(notification);
  const isSeen = Boolean(notification.last_seen_at);

  return (
    <Button
      variant={isSeen ? 'ghost' : 'primary'}
      size="xs"
      icon={isSeen ? 'eye-slash' : 'eye'}
      onClick={handleToggle}
      title={isSeen ? 'Mark not seen' : 'Mark seen'}
    />
  );
}

export function MarkAllSeen(): ReactElement | null {
  const { mutate } = useTable();
  const { indicators, invalidate } = useIndicatorsContext();

  if (!indicators.unseen_notifications) {
    return null;
  }
  return (
    <Button
      variant="primary"
      size="sm"
      icon="eye"
      onClick={async () => {
        await mutate(
          async (data) => {
            invariant(data);
            await fetcher({
              method: 'POST',
              url: `notifications/notifications/mark_all_seen/`,
            });
            return data;
          },
          { revalidate: true },
        );
        await invalidate('unseen_notifications');
      }}
    >
      Mark all
    </Button>
  );
}
